import { Component, OnInit, AfterViewInit,OnDestroy,HostListener,Input} from '@angular/core';
import { DrawingToolService } from '../../services/drawingtool.service';

import * as $ from "jquery";
@Component({
  selector: 'app-keyboard-tool',
  templateUrl: './keyboard-tool.component.html',
  styleUrls: ['./keyboard-tool.component.scss']
})
export class KeyboardToolComponent implements OnInit, AfterViewInit,OnDestroy {
  @HostListener('window:resize', ['$event'])
  onResize(event)
    {
      var thisme=this;
        //resizing 100 milli second time for getting actual height elements
        setTimeout(function () {
          thisme.reset_keyboard_after_resize();
        }, 100);
    }

public layouts = {
      english: [
          [
            {
            type:'letter',
            text:'q',
            },
            {
            type:'letter',
            text:'w',
            },
            {
            type:'letter',
            text:'e',
            },
            {
            type:'letter',
            text:'r',
            },
            {
            type:'letter',
            text:'t',
            },
            {
            type:'letter',
            text:'y',
            },
            {
            type:'letter',
            text:'u',
            },
            {
            type:'letter',
            text:'i',
            },
            {
            type:'letter',
            text:'o',
            },
            {
            type:'letter',
            text:'p',
            },
            {
            type:'letter',
            text:'å',
            },
            {
            type:'letter',
            text:'?',
            },
          ],
          [
            {
            type:'letter',
            text:'a'
            },
            {
            type:'letter',
            text:'s'
            },
            {
            type:'letter',
            text:'d'
            },
            {
            type:'letter',
            text:'f'
            },
            {
            type:'letter',
            text:'g'
            },
            {
            type:'letter',
            text:'h'
            },
            {
            type:'letter',
            text:'j'
            },
            {
            type:'letter',
            text:'k'
            },
            {
            type:'letter',
            text:'l'
            },
            {
            type:'letter',
            text:'ö'
            },
            {
            type:'letter',
            text:'ä'
            },
            {
            type:'letter',
            text:'.'
            }
          ],
          [
          {
          type:'shift',
          text:'&nbsp;'
          },
          {
          type:'letter_z letter',
          text:'z'
          },
          {
          type:'letter',
          text:'x'
          },
          {
          type:'letter',
          text:'c'
          },
          {
          type:'letter',
          text:'v'
          },
          {
          type:'letter',
          text:'b'
          },
          {
          type:'letter',
          text:'n'
          },
          {
          type:'letter',
          text:'m'
          },
          {
          type:'backspace',
          text:'&nbsp;'
        }],
          [
          {
          type:'numeric_switch',
          text:'123'
          },
          {
          type:'space',
          text:'&nbsp;'
          },
          {
          type:'return',
          text:'&nbsp;'
          },
          ]
      ],
      numeric: [
        [
          {
          type:'letter',
          text:'1',
          },
          {
          type:'letter',
          text:'2',
          },
          {
          type:'letter',
          text:'3',
          },
          {
          type:'letter',
          text:'4',
          },
          {
          type:'letter',
          text:'5',
          },
          {
          type:'letter',
          text:'6',
          },
          {
          type:'letter',
          text:'7',
          },
          {
          type:'letter',
          text:'8',
          },
          {
          type:'letter',
          text:'9',
          },
          {
          type:'letter',
          text:'0',
          },
          {
          type:'letter',
          text:'+',
          },
          {
          type:'letter',
          text:'-',
          }
        ],
        [
          {
          type:'letter',
          text:':',
          },
          {
          type:'letter',
          text:';',
          },
          {
          type:'letter',
          text:'(',
          },
          {
          type:'letter',
          text:')',
          },
          {
          type:'letter',
          text:'$',
          },
          {
          type:'letter',
          text:'&',
          },
          {
          type:'letter',
          text:'@',
          },
          {
          type:'letter',
          text:'"',
          },
          {
          type:'letter',
          text:'%',
          },
          {
          type:'letter',
          text:'=',
          },
          {
          type:'letter',
          text:'*',
          },
          {
          type:'letter',
          text:'/',
          }
        ],
        [
          {
          type:'symbol_switch',
          text:'#+=',
          },
          {
          type:'letter',
          text:'.',
          },
          {
          type:'letter',
          text:',',
          },
          {
          type:'letter',
          text:'?',
          },
          {
          type:'letter',
          text:'!',
          },
          {
          type:'letter',
          text:"'",
          },
          {
            type:'backspace',
            text:'&nbsp;'
          }
        ],
        [
          {
          type:'character_switch',
          text:'abc',
          },
          {
          type:'space',
          text:'&nbsp;'
          },
          {
          type:'return',
          text:'&nbsp;'
          },
        ]
      ],
      numbers_only: [
        ['1', '2', '3',],
        ['4', '5', '6',],
        ['7', '8', '9',],
        ['0', 'return', 'backspace'],
      ],
      symbolic: [
        [
          {
          type:'letter',
          text:'[',
          },
          {
          type:'letter',
          text:']',
          },
          {
          type:'letter',
          text:'{',
          },
          {
          type:'letter',
          text:'}',
          },
          {
          type:'letter',
          text:'#',
          },
          {
          type:'letter',
          text:'%',
          },
          {
          type:'letter',
          text:'^',
          },
          {
          type:'letter',
          text:'*',
          },
          {
          type:'letter',
          text:'+',
          },
          {
          type:'letter',
          text:'=',
          }
        ],
        [
          {
          type:'letter',
          text:'_',
          },
          {
          type:'letter',
          text:'\\',
          },
          {
          type:'letter',
          text:'|',
          },
          {
          type:'letter',
          text:'~',
          },
          {
          type:'letter',
          text:'<',
          },
          {
          type:'letter',
          text:'>',
          }
        ],
        [
          {
          type:'numeric_switch',
          text:'123',
          },
          {
          type:'letter',
          text:'.',
          },
          {
          type:'letter',
          text:',',
          },
          {
          type:'letter',
          text:'?',
          },
          {
          type:'letter',
          text:'!',
          },
          {
          type:'letter',
          text:"'",
          },
          {
          type:'backspace',
          text:'&nbsp;'
          }
        ],
        [
            {
            type:'character_switch',
            text:'abc',
            },
            {
            type:'space',
            text:'&nbsp;'
            },
            {
            type:'return',
            text:'&nbsp;'
            },
        ]
      ]
    };
public alphabets:any=this.layouts.english;
public numeric:any=this.layouts.numeric;
public symbolic:any=this.layouts.symbolic;
public uppercase:any="";
public current_letters:any;
public currentpage="";


  constructor(public drawingtoolService: DrawingToolService)
  {
    this.current_letters=this.alphabets;
  }

  ngOnInit()
  {
     this.currentpage=`${this.drawingtoolService.sectionInfo.current_section}_${this.drawingtoolService.sectionInfo.current_book_name}`;
  }
  async ngAfterViewInit()
  {
  }

  ngOnDestroy()
  {
  }

  letterClick({text,type})
  {
    var text_data="";
    if(type=="letter")
    {
      text_data=text;
      if(this.uppercase!="")
      {
        text_data=text_data.toUpperCase();
      }
    }
    else if(type=="space")
    {
      text_data=" ";
    }
    else if(type=="shift" || type=="return")
    {
      //this.uppercase="";
      if(type=="shift")
      {
        if(this.uppercase=="uppercase")
        {
          this.uppercase="";
        }
        else
        {
          this.uppercase="uppercase";
        }
      }
      else
      {
        text_data="\n";
      }
    }
    else if(type=="backspace")
    {
      this.backspace();
    }
    else if(type=="character_switch" || type=="numeric_switch" || type=="symbol_switch")
    {
      this.uppercase="";
      if(type=="symbol_switch")
      {
        this.current_letters=this.symbolic;
      }
      else if(type=="numeric_switch")
      {
        this.current_letters=this.numeric;
      }
      else
      {
        this.current_letters=this.alphabets;
      }
    }

    if(text_data && text_data!="")
    {
      this.typeLetter(text_data);     
    }   

  }

  insertToString(start, end, string, insert_string)
  {
    return string.substring(0, start) + insert_string + string.substring(end, string.length);
  }

  backspace()
  {
    const search_field:any =document.getElementById("search_field");
    let input = search_field,
      input_node = search_field,
      start = input_node.selectionStart,
      val = input.value;

    if (start > 0) {
      input.value=val.substring(0, start - 1) + val.substring(start);
      input.focus();
      input_node.setSelectionRange(start - 1, start - 1);
    }
    else {
        input.focus();
      input_node.setSelectionRange(0, 0);
    }
  }

  typeLetter(key)
  {
    const search_field:any =document.getElementById("search_field");
    let input:any = search_field,
      val = input.value,
      input_node = input,
      start = input_node.selectionStart,
      end = input_node.selectionEnd;

    var max_length = $("#search_field").attr("maxlength");
    if (start === end && end === val.length) {
      if (!max_length || val.length < max_length) {
        input.value=val + key;
      }
    } else {
      var new_string = this.insertToString(start, end, val, key);
      input.value=new_string;
      start++;
      end = start;
      input_node.setSelectionRange(start, end);
    }
    input.focus();
  }



  //--------------------------------draggable start---------------------------------------------------//
  public draggedCount = 0;

  public startX = 0;
  public startY = 0;
  public x = 0;
  public y = 0;
  public Mouse_XPos = 0;
  public Mouse_YPos = 0;

  onmousemove:any;
  onmouseup:any;

  public last_top=0;
  public last_left=0;

  public last_top_px="";
  public last_left_px="";

  dragKeyboard(event){
    event.preventDefault();
    let {pageX,pageY} = event
    this.Mouse_XPos = pageX;
    this.Mouse_YPos = pageY;
    this.startX =pageX - this.x;
    this.startY =pageY - this.y;

    if (! this.onmousemove)
    {
         this.onmousemove = this.mousemove.bind(this);
     }
     if (!this.onmouseup)
     {
         this.onmouseup = this.mouseup.bind(this);
     }
    document.addEventListener("mousemove", this.onmousemove,false);
    document.addEventListener("mouseup",this.onmouseup,false);
  }
  mousemove(event) {
    if (this.Mouse_XPos !== event.pageX && this.Mouse_YPos !== event.pageY) {
      
      this.drawingtoolService.smoothScrollIframePages(true);
      var parentDiv = document.getElementById("wPaint");
      var x = event.pageX - parentDiv.offsetLeft;
      var y = event.pageY - parentDiv.offsetTop;

      var elmnt = document.getElementById("wPaint");
      var width_screen = elmnt.clientWidth;
      var height_screen = elmnt.clientHeight;

      var elmnt2 = document.getElementById("keyboardContainer");
      var menuContainer_h = elmnt2.clientHeight;
      var menuContainer_w = elmnt2.clientWidth;

      var test_y = (height_screen - menuContainer_h);

      if (y > test_y)
      {
        y = test_y;
      }


      var test_x = (width_screen - menuContainer_w);
      if (x > test_x)
      {
        x = test_x;
      }

      if (x < 0) {
        x = 0;
      }


      if (y < 0)
      {
        y = 0;
      }

      this.last_top = y;
      this.last_left = x;

      this.last_left_px= x + "px";
      this.last_top_px= y + "px";

    }
  }
  mouseup() {
    this.drawingtoolService.smoothScrollIframePages(false);
    this.draggedCount = this.draggedCount + 1;
    document.removeEventListener("mousemove", this.onmousemove,false);
    document.removeEventListener("mouseup", this.onmouseup,false);
  }

  reset_keyboard_after_resize(){
    //height and width of the canvas
    const elmnt:any = document.getElementById("wPaint");
    //height and width of the keyboard
    const elmnt2:any = document.getElementById("keyboardContainer");
    if(elmnt && elmnt!="" &&  elmnt2 && elmnt2!="" ) {
      var width_screen = elmnt.clientWidth;
      var height_screen = elmnt.clientHeight;

      var menuContainer_h = elmnt2.clientHeight;
      var menuContainer_w = elmnt2.clientWidth;

      var test_y = (height_screen - menuContainer_h);
      var y = this.last_top;
      var x = this.last_left;

      if (y > test_y)
      {
        y = test_y;
      }

      var test_x = (width_screen - menuContainer_w);

      if (x > test_x)
      {
        x = test_x;
      }

      if (x < 0) {
        x = 0;
      }

      if (y < 0) {
        y = 0;
      }

      if(y>0 && x>0)
      {
        this.last_top = y;
        this.last_left = x;

        this.last_left_px= x + "px";
        this.last_top_px= y + "px";
      }

    }

  }


  onmousemove_btn:any;
  onmouseup_btn:any;

  dragMouseDown({type,text})
  {
    if(this.drawingtoolService.sectionInfo.current_section!=this.drawingtoolService.berattelse_section)
    {
      var text_data="";
      if(type=="letter")
      {
        text_data=text;
        if(this.uppercase!="")
        {
          text_data=text_data.toUpperCase();
        }

        let keyboard:any=window['keyboard'];
        let createKeyboardDragger:any=window['createKeyboardDragger'];

        if (this.drawingtoolService.sectionInfo.current_section == this.drawingtoolService.matteladan_section)
        {
          let matService:any=window['matService'];
          createKeyboardDragger(matService,keyboard, text_data);
        }
        else
        {
          createKeyboardDragger(keyboard, text_data);
        }
      }
      if (! this.onmousemove_btn)
      {
           this.onmousemove_btn = this.elementDrag.bind(this);
       }
       if (!this.onmouseup_btn)
       {
           this.onmouseup_btn = this.closeDragElement.bind(this);
       }
      document.addEventListener("mousemove", this.onmousemove_btn,false);
      document.addEventListener("mouseup",this.onmouseup_btn,false);
    }
  }

  elementDrag(e) {
    if(this.drawingtoolService.sectionInfo.current_section!=this.drawingtoolService.berattelse_section)
    {
      var isDragging = true;
      let draggingKeyboardText:any=window['draggingKeyboardText'];
      let keyboard:any=window['keyboard'];
      if (this.drawingtoolService.sectionInfo.current_section == this.drawingtoolService.matteladan_section)
      {
        let matService:any=window['matService'];
        draggingKeyboardText(matService, isDragging, keyboard, e);
      }
      else
      {
        draggingKeyboardText(keyboard, e);
      }
    }
  }

  closeDragElement(e) {
    if(this.drawingtoolService.sectionInfo.current_section!=this.drawingtoolService.berattelse_section)
    {
        var isDragging = true;
        let keyboard:any=window['keyboard'];
        let droppingKeyboardText:any=window['droppingKeyboardText'];

        if (this.drawingtoolService.sectionInfo.current_section == this.drawingtoolService.matteladan_section)
        {
          let matService:any=window['matService'];
          droppingKeyboardText(matService, isDragging, keyboard, e);
        }
        else
        {
          droppingKeyboardText(keyboard, e);
        }

        document.removeEventListener("mousemove", this.onmousemove_btn,false);
        document.removeEventListener("mouseup", this.onmouseup_btn,false);
    }
  }


}
